import React, { useEffect, useState ,useRef} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 import PartailOfflineList from './PartailOfflineList';
 import ActiveInactiveList from './ActiveInactiveList';

const Version_abstract_data = async () => { 
    const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/active_inactive`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  };
const Version_abstract = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const fpstab = useRef(null); // Use ref to scroll to this div
    const [renderContenttttt, setRenderContenttttt] = useState(null);
    const details3 = useRef(null); // Use ref to scroll to this div

    const [version, setVersion] = useState(null);

    const handleFPSClick = (status,dist_code) => {
      setRenderContenttttt(null);

      setTimeout(() => {

        setRenderContenttttt(() => {
             
if(status==='O'){
return(<PartailOfflineList  

  status={status}
  dist_code={dist_code} />
);
}else if(status==='PD')
{
  return(
    <PartailOfflineList  
    status={status}
  dist_code={dist_code} />
  );
}  

else if(status==='PN'){
  return(
    <PartailOfflineList  
    status={status}
  dist_code={dist_code} />
  );
}


else if(status==='D') {
  return(
    <ActiveInactiveList  
    status={status}

  dist_code={dist_code} />
  );
}



else if(status==='A') {
  return(
    <ActiveInactiveList  
    status={status}
    dist_code={dist_code}
    />
  );
}




else if(status==='I') {
  return(
    <ActiveInactiveList  
    status={status}
    dist_code={dist_code}
    />
  );
}




});
      }, 10);
  };


    useEffect(() => {
      const getData = async () => {
        try {
          const response_data = await Version_abstract_data();
  
          if (response_data.data && response_data.data.length > 0) {
            setReportData(response_data.data);
            setTabHeading(response_data.heading);

            //setVersion(response_data.headerversionNo)
          } else {
            setReportData([]);
          }
        } catch (errorr) {
            return <div className="mainhead" align="center">Internal error</div>;
        } finally {
          setLoading(false);
        }
      };
  
      getData();
    }, []);
  
    useEffect(() => {
      if (!loading && !error && reportData.length > 0 && details3.current) {
        details3.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, [loading, error, reportData]);
  
    if (loading) {
      return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
          <CircularProgress />
      </Box></div>
  }
  if (error) {
      return <div class="mainhead" align="center">
      Internal Error
      </div>
    }
    if (reportData.length === 0) {
        return <div class="mainhead" align="center">
		{/*No data found */}
        {tabHeading}
 	</div>
      }
    // Calculate totals for each column
    const totals = reportData.reduce(
      (acc, item) => {
        acc.total_shops += parseInt(item.total_shops) || 0;
        acc.total_poff += item.total_poff || 0;
        acc.downloaded += item.downloaded || 0;
        acc.notdownloaded += item.notdownloaded || 0;
        acc.active_shops += item.active_shops || 0;
        acc.inactive_shops += item.inactive_shops || 0;
        acc.trans += item.trans || 0;

        
        return acc;
      },
      {
        total_shops: 0,
        total_poff: 0,
        downloaded: 0,
        notdownloaded :0,
        active_shops:0,
        inactive_shops :0,
        trans:0
      }
    );
    
    return (
      <><br/><br/>
        <table ref={fpstab} align="center" width="60%" border={1}>
          <thead>
            <tr className="tableheader">
              <th colSpan={9}> {tabHeading} </th>
            </tr>
            <tr className="tableheader">
              <th rowSpan={2}>Sl.No</th>
              <th rowSpan={2}>District</th>
              <th rowSpan={2}>Total</th>
              <th colSpan={3}>Partial Offline</th>
              <th colSpan={2}>Current Status</th>
              <th rowspan={2}>FPS<br/>Performed<br/>Transaction Today</th>
             </tr>
           
        <tr class="tableheader">	
			<th>Total</th>
			<th>Data<br/>Downloaded</th>
			<th>Data<br/>Not Downloaded</th>
								
			<th>Active</th>
			<th>Inactive</th>
	{	/*	<!-- <th>Logged in</th> 
			<th>Logged in <br/>&<br/>Performed Trans</th> -->  */}
			</tr>


          </thead>
          <tbody>
            {reportData.map((item, index) => (
              <tr key={item.dist_code}>
                <td  style={{ textAlign: 'center' }}>{index + 1}</td>
                <td style={{ textAlign: 'left' }}>{item.dist_name_en}</td> 
                <td style={{ textAlign: 'right' }}>{item.total_shops}</td>


             { /*  <td style={{ textAlign: 'right' }}>{item.total_poff}</td> */}


 <td style={{ textAlign: 'right' }}>
                {item.total_poff === 0 ? (
    item.total_poff
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('O',item.dist_code)}
    >
      {item.total_poff}
    </a>
  )}
                 </td>

              
                <td style={{ textAlign: 'right' }}>
                {item.downloaded === 0 ? (
    item.downloaded
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('PD',item.dist_code)}
    >
      {item.downloaded}
    </a>
  )}
                 </td>

                 <td style={{ textAlign: 'right' }}>
                 {item.notdownloaded === 0 ? (
    item.notdownloaded
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('PN',item.dist_code)}
    >
      {item.notdownloaded}
    </a>
  )}
               
                 </td> 
 
              
              <td style={{ textAlign: 'right' }}>
                 {item.active_shops === 0 ? (
    item.active_shops
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('A',item.dist_code)}
    >
      {item.active_shops}
    </a>
  )}
               
                 </td> 

 
                 <td style={{ textAlign: 'right' }}>
                 {item.inactive_shops === 0 ? (
    item.inactive_shops
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('I',item.dist_code)}
    >
      {item.inactive_shops}
    </a>
  )}
               
                 </td> 

              

 
             <td style={{ textAlign: 'right' }}> {item.trans}</td>
              </tr>
            ))}



            
            <tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_shops}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_poff}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.downloaded}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.notdownloaded}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.active_shops}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.inactive_shops}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.trans}</td>


            </tr>
          </tbody>
        </table>
        <br /><br />
        <div id='detailsRR' ref={details3}>{renderContenttttt}</div>
        <br /><br />
        <br /><br />
        <br /><br />

      </>
    );
  };
  
  export default Version_abstract;
  